import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { createContext, useContext } from "react";
import { SPACE_CHROME_COLOR_VARIABLE } from "#space-backdrop-palette";

/**
 * True beneath a chrome surface that paints the sky (the toolbar row, the top-corner controls, the
 * Learn action area), so floating glass there can see through to it. Provide it with
 * `<SpaceSkySurfaceContext value={…}>`.
 */
export const SpaceSkySurfaceContext = createContext(false);

/** Whether this device has the experimental space background on. */
export function useIsSpaceBackgroundEnabled(): boolean {
  const [isSpaceBackgroundEnabled] = useDeviceSetting("isSpaceBackgroundEnabled");
  return isSpaceBackgroundEnabled;
}

/**
 * The colour token a fade over a `bg-muted` chrome surface should dissolve into: the sky while
 * the space background is on, `fallback` otherwise.
 */
export function useSpaceSurfaceColorVariable(fallback: string): string {
  return useIsSpaceBackgroundEnabled() ? SPACE_CHROME_COLOR_VARIABLE : fallback;
}

/** Whether this sits on a surface that is currently showing the sky. */
export function useIsOverSpaceSky(): boolean {
  const isSkySurface = useContext(SpaceSkySurfaceContext);
  return useIsSpaceBackgroundEnabled() && isSkySurface;
}
